
import * as React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { GripVertical } from "lucide-react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export interface SortableItemProps {
  id: string;
  label: string;
  index: number;
  checked: boolean;
  isCustom?: boolean;
  onCheckedChange: () => void;
}

const SortableItem = ({ id, label, index, checked, isCustom, onCheckedChange }: SortableItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1 : 0,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`flex items-center gap-2 px-2 py-1.5 cursor-pointer hover:bg-accent hover:text-accent-foreground ${
        isDragging ? "bg-accent" : ""
      } ${isCustom ? "italic" : ""}`}
    >
      {checked && (
        <div {...attributes} {...listeners} className="cursor-grab">
          <GripVertical className="w-4 h-4 text-gray-400" />
        </div>
      )}
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
      <label
        htmlFor={id}
        className="text-sm font-medium cursor-pointer flex-1"
      >
        {checked && <span className="mr-2 text-gray-500">#{index + 1}</span>}
        {label}
      </label>
    </div>
  );
};

export default SortableItem;
